import * as Sentry from '@sentry/react';

export function initSentry() {
    const dsn = import.meta.env.VITE_SENTRY_DSN;
    if (!dsn) return;

    Sentry.init({
        dsn,
        release: import.meta.env.VITE_BUILD_RELEASE || undefined,
        environment: import.meta.env.VITE_ENVIRONMENT || 'development',
        tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.2 : 1.0,
        sendDefaultPii: false,
    });
}
